import moment from "moment";
import { FormatNumber2 } from "../../../utility/functions/formatNumber";

export const SummaryColumns = (width, openingBalDetails) => {
  const columns = [
    {
      field: "DATE",
      accessor: "DATE",
      type: "string",
      width: width < 768 ? 100 : width < 1400 ? 120 : 120,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value ? moment(param.value).format("YYYY-MM-DD") : ""}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Date
        </div>
      ),
    },
    {
      field: "VOUCHER_NO",
      accessor: "VOUCHER_NO",
      type: "string",
      width: 100,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Voucher No.
        </div>
      ),
    },

    {
      field: "ACCOUNT_NAME",
      accessor: "ACCOUNT_NAME",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 280,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Party Name
        </div>
      ),
    },
    {
      field: "LEDGER_NAME",
      accessor: "LEDGER_NAME",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 180,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Ledger Name
        </div>
      ),
    },
    {
      field: "TRANSACTION_TYPE",
      accessor: "TRANSACTION_TYPE",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 200,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={`  w-full  flex items-center   h-full bg-gray-200`}>
            <select className="outline-none bg-transparent py-1">
              {[
                "Cash",
                "Check",
                "NEFT/RTGS",
                "DD",
                "Bank Transfer",
                "International Transaction",
                "Other",
              ].map((c) => {
                return <option value={c}>{c}</option>;
              })}
            </select>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Transaction Type
        </div>
      ),
    },
    {
      field: "INSTRUMENT_NUMBER",
      accessor: "INSTRUMENT_NUMBER",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 100,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Inst. Number
        </div>
      ),
    },
    {
      field: "INSTRUMENT_DATE",
      accessor: "INSTRUMENT_DATE",
      type: "string",
      width: width < 768 ? 150 : width < 1400 ? 150 : 150,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value ? moment(param.value).format("YYYY-MM-DD") : ""}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Instrument Date
        </div>
      ),
    },
    {
      field: "BANK_NAME",
      accessor: "BANK_NAME",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 200,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Bank Name
        </div>
      ),
    },
    {
      field: "NARRATION",
      accessor: "NARRATION",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 250,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Narration
        </div>
      ),
    },
    {
      field: "DEBIT",
      accessor: "DEBIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 150,
      align: "right",
      renderCell: (param) => {
        const debit = param.value ? param.value : 0;
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {debit !== 0 ? FormatNumber2(debit) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Debit
        </div>
      ),
    },
    {
      field: "CREDIT",
      accessor: "CREDIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 150,
      align: "right",
      renderCell: (param) => {
        const Credit = param.value ? param.value : 0;
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {Credit !== 0 ? FormatNumber2(Credit) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Credit
        </div>
      ),
    },
    {
      field: "CLEARANCE_DATE",
      accessor: "CLEARANCE_DATE",
      type: "string",
      width: width < 768 ? 200 : width < 1400 ? 200 : 200,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value ? moment(param.value).format("YYYY-MM-DD") : ""}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Clearance Date
        </div>
      ),
    },
  ];

  return columns;
};
